import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  TabPanel: {
    width: '100%',
  },
  Dashboard: {
    height: '100%',
    display: 'flex',
  },
  Order: {
    paddingTop: '24px',
    height: '100%',
    overflowY: 'auto',
    flex: '1 1 auto',
    transition: 'width 0.3s ease-in-out',
    position: 'relative',
    backgroundColor: '#FFF',
  },
  Title: {
    color: 'var(--Gray-900, #101828)',
    padding: '0 24px',
  },

  PreOrderShow: {
    padding: '16px',
    background: 'var(--Gray-100, #F2F4F7)',
    boxShadow: '0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)',
    position: 'relative',
    transition: 'width 0.3s ease-in-out, min-width 0.3s ease-in-out, padding 0.3s ease-in-out',
    // overflowY: 'auto',
    // minHeight: '100vh',
  },
  PreOrderHide: {
    paddingTop: '10px',
    paddingLeft: '10px',
    position: 'relative',
    transition: 'width 0.3s ease-in-out, min-width 0.3s ease-in-out, padding 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    background: 'var(--Gray-100, #F2F4F7)',
    boxShadow: '0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)',
  },

  PreOrderToggleButton: {
    position: 'absolute',
    left: '-40px',
    top: '20px',
    zIndex: 1000,
    padding: '0px',
    height: '42px',
    minWidth: '42px',
    borderRadius: '8px 0 0 8px',
    background: 'var(--Gray-100, #F2F4F7)',
    boxShadow: '-3px 2px 4px -3px rgba(0, 0, 0, 0.15), -3px 2px 4px -3px rgba(0, 0, 0, 0.2)',
    '&:hover': {
      backgroundColor: 'var(--Gray-100, #F2F4F7)',
      boxShadow: '-3px 2px 4px -3px rgba(0, 0, 0, 0.15), -3px 2px 4px -3px rgba(0, 0, 0, 0.2)',
    },
    transition: 'all 0.2s ease-in-out',
  },
  PreOrderContentShow: {
    opacity: 1,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'opacity 0.4s ease-in-out 0.1s, transform 0.4s ease-in-out 0.1s',
    visibility: 'visible',
  },
  PreOrderContentHide: {
    opacity: 0,
    width: '0',
    height: '0',
    transition: 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out, width 0.2s ease-in-out, height 0.2s ease-in-out',
    visibility: 'hidden',
    pointerEvents: 'none',
    overflow: 'hidden',
  },
  PreOrderList: { flex: 1, display: 'flex', flexDirection: 'column', height: '100%', paddingTop: '16px', gap: '12px', overflowY: 'auto' },
}));

export { useStyles };

